
import {
  schema, normalize
} from 'normalizr';

// Define reoprting schema
const reportingSchema = new schema.Entity('reporting')
const reoprtingListSchema = [reportingSchema]

export function adaptReportingsToStore(response) {
  const apiData = response.data
  const apiResults = apiData.results ? apiData.results : apiData
  const entries = normalize(apiData, reoprtingListSchema)
  return {
    entries: entries.entities.reoprtings,
    count: apiData.count ? apiData.count : apiData.length,
    next: apiData.next ? apiData.next : '',
    previous: apiData.previous ? apiData.previous : '',
    results: apiResults
  }
}

export function adaptReportToStore({ data }) {
  return data
}

export function adaptReportDownload(response) {
  return response
}
